import { Locale } from "@linkfluence/models/locale";

export type Format = {
  DECIMAL_SEP: string;
  GROUP_SEP: string;
  PATTERNS: {
    gSize: number;
    lgSize: number;
    maxFrac: number;
    minFrac: number;
    minInt: number;
    negPre: string;
    negSuf: string;
    posPre: string;
    posSuf: string;
  };
  DECIMAL_MARK: string;
  SUFFIXES: Array<string>;
  COLON_SEPARATOR: string;
};

const FORMATS = {
  [Locale.Chinese]: {
    DECIMAL_SEP: ".",
    GROUP_SEP: ",",
    PATTERNS: {
      gSize: 3,
      lgSize: 3,
      maxFrac: 3,
      minFrac: 0,
      minInt: 1,
      negPre: "-",
      negSuf: "",
      posPre: "",
      posSuf: "",
    },
    DECIMAL_MARK: ".",
    SUFFIXES: ["千", "百万", "十亿", "兆", "P"],
    COLON_SEPARATOR: ": ",
  },
  [Locale.German]: {
    DECIMAL_SEP: ",",
    GROUP_SEP: ".",
    PATTERNS: {
      gSize: 3,
      lgSize: 3,
      maxFrac: 3,
      minFrac: 0,
      minInt: 1,
      negPre: "-",
      negSuf: "",
      posPre: "",
      posSuf: "",
    },
    DECIMAL_MARK: ",",
    SUFFIXES: ["T", "Mio.", "Mrd.", "T", "P"],
    COLON_SEPARATOR: ": ",
  },
  [Locale.English]: {
    DECIMAL_SEP: ".",
    GROUP_SEP: ",",
    PATTERNS: {
      gSize: 3,
      lgSize: 3,
      maxFrac: 3,
      minFrac: 0,
      minInt: 1,
      negPre: "-",
      negSuf: "",
      posPre: "",
      posSuf: "",
    },
    DECIMAL_MARK: ".",
    SUFFIXES: ["k", "m", "bn", "T", "P"],
    COLON_SEPARATOR: ": ",
  },
  [Locale.French]: {
    DECIMAL_SEP: ",",
    GROUP_SEP: "\u2009",
    PATTERNS: {
      gSize: 3,
      lgSize: 3,
      maxFrac: 3,
      minFrac: 0,
      minInt: 1,
      negPre: "-",
      negSuf: "",
      posPre: "",
      posSuf: "",
    },
    DECIMAL_MARK: ",",
    SUFFIXES: ["K", "M", "Md", "T", "P"],
    COLON_SEPARATOR: " : ",
  },
};

export function getFormatFromLocale(locale: Locale): Format {
  return FORMATS[locale] || FORMATS[Locale.English];
}
